import { ErrorMessage } from "@hookform/error-message";
import { Controller } from "react-hook-form";
import Select from "react-select";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  label: string;
  data: string[];
  formatOption?: (option: string) => string;
};

export default function EnumSelect({ name, label, data, formatOption }: Props) {
  return (
    <div className="sm:col-span-4">
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1 flex gap-2 border-0 bg-transparent py-1.5">
        <Controller
          name={name}
          render={({ field }) => (
            <Select
              className="!text-gray-900 sm:text-sm sm:leading-6 flex-grow"
              classNames={{
                control: (state) =>
                  state.isFocused
                    ? "!border-sky-600 !shadow-sm"
                    : "border-grey-300",
                option: () => "!text-gray-900",
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#bae6fd",
                },
              })}
              options={data.map((value) => ({
                label: formatOption ? formatOption(value) : value,
                value,
              }))}
              isClearable={false}
              isSearchable={true}
              {...field}
              onChange={(e) => field.onChange(e?.value)}
              value={
                field?.value
                  ? {
                      value: field.value,
                      label: formatOption
                        ? formatOption(field.value)
                        : field.value,
                    }
                  : null
              }
            />
          )}
        />
        <div className="flex-none p-1.5">
          <div className="w-5" />
        </div>
      </div>
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </div>
  );
}
